/* eslint-disable */
import React, { useState, useEffect } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { FaBars, FaRegWindowClose, FaHome } from "react-icons/fa";
import { Header } from "../global/Header";
import { ViewModels } from "./SidebarFormat";

export default function FSideBar({ children }) {
  const [isopen, setOpen] = useState(false);
  const [sideshow, setSideShow] = useState(false);
  const [role, setRole] = useState("");
  const [userName, setUserName] = useState("")
  const location = useLocation();
  const [permission, setPermissions] = useState([]);
  const [filteredModules, setFilteredModules] = useState([]);
  

  const toggle = () => {
    setOpen(!isopen);
  };

  useEffect(() => {
    const pathsToHideSidebar = ["/", "/error"]; 

    if (!pathsToHideSidebar.includes(location.pathname)) {
      setSideShow(true);
    } else {
      setSideShow(false);
    }
 if (location.pathname === "/") {
      localStorage.removeItem("data");
    }
  }, [location]);

  const isSubmenuActive = () => {
    return ViewModels.some((menu) =>
      menu.SubMenus.some((submenu) => location.pathname.includes(submenu.Href))
    
    );
  };

useEffect(() => {
  const data = JSON.parse(localStorage.getItem("loginData"));
  const userName = (data?.name || "").toUpperCase();
  const perms = data?.permission || []; // assuming permission is inside loginData
  setRole(data?.role)
  setUserName(userName);
  setPermissions(perms);
}, [location]);

useEffect(() => {
  getFilteredViewModels();
}, [role, permission]);


function getFilteredViewModels() {
  if (role?.toLowerCase() === "user") {
    const allowedModules = permission.map((perm) => perm.module.toLowerCase());

    const filtered = ViewModels.filter((item) =>
      allowedModules.includes(item.State?.toLowerCase())
    );

    setFilteredModules(filtered);
  } else {
    setFilteredModules(ViewModels);
  }
}


  return (
    <>
      <Header />
      {sideshow && (
        <div className="side">
          <div className="menu-bar">
            <div
              className={isopen ? "active side-menus" : "noactive side-menus"}
            >
              <div className="admin-block">
                <h2 style={{ display: isopen ? "block" : "none" }}>{userName}</h2>
                <div className="bar" onClick={toggle} style={{ cursor: 'pointer' }}>
                  <FaBars />
                </div>
              </div>
              
              {/* Mobile menu toggle trigger */}
              <div className="mobile-toggle-btn" onClick={toggle}>
                {isopen ? <FaRegWindowClose /> : <FaBars />}
              </div>

              {isSubmenuActive() ? (
  <div className="submenu-item">
    {filteredModules.map((menu) =>
      menu.SubMenus?.map((submenu, subIndex) => (
        <div className="menus-item" key={subIndex} title={submenu.Title}>
          <NavLink to={submenu.Href} className="link" style={{ justifyContent: isopen ? "" : "center" }}>
            <div className="link-icon">
              <span>{submenu.Icon}</span>
            </div>
            <div className="text-box" style={{ display: isopen ? "block" : "none" }}>
              <p className="link-text">{submenu.Title}</p>
            </div>
          </NavLink>
        </div>
      ))
    )}
  </div>
) : (
  <div className="main-menu">
  {/*  Dashboard item */}
  <div className="menus-item" title="DASHBOARD">
    <NavLink to="/dashboard" className="link" style={{ justifyContent: isopen ? "" : "center" }}>
      <div className="link-icon">
         <span>{<FaHome />}</span>
      </div>
      <div className="text-box" style={{ display: isopen ? "block" : "none" }}>
        <p className="link-text">DASHBOARD</p>
      </div>
    </NavLink>
  </div>

  {/* other filtered menus */}
  {filteredModules.map((menu, index) => (
    <div className="menus-item" key={index} title={menu.Title}>
      <NavLink to={menu.Href} className="link" style={{ justifyContent: isopen ? "" : "center" }}>
        <div className="link-icon">
          <span>{menu.Icon}</span>
        </div>
        <div className="text-box" style={{ display: isopen ? "block" : "none" }}>
          <p className="link-text">{menu.Title}</p>
        </div>
      </NavLink>
    </div>
  ))}
</div>

)}


            </div>
            <main>{children}</main>
          </div>
        </div>
      )}
      {!sideshow && <div className="main-content">{children}</div>}
    </>
  );
}
